import { useRef } from "react";
import { BackSide } from "three/src/constants";

function Panorama({ texture }) {
	let mesh = useRef(null);

	return (
		<>
			<mesh scale={[-1, 1, 1]} layers={3} ref={mesh}>
				<sphereBufferGeometry args={[500, 60, 40]} />
				<meshBasicMaterial map={texture} side={BackSide} depthWrite={false} />
			</mesh>
		</>
	);
}
export default Panorama;
